<ng-container *ngIf="!loading">
    <div class="header-c">
        <strong>
            Moda de Cargas
        </strong>
    </div>

    <table>
        <thead>
            <tr>
                <th style="text-transform: uppercase;">Producto</th>
                <th style="text-transform: uppercase;">Litros</th>
                <th style="text-transform: uppercase;">Monto $</th>
            </tr>
        </thead>
        <tbody class="table-body">
            <tr *ngFor="let product of productsData; let i = index">
              <td [ngClass]="{
                'text-regular': product.name === 'Regular',
                'text-premium': product.name === 'Premium',
                'text-diesel':  product.name === 'Diesel'
              }">
                <strong>{{ product.name }}</strong>
              </td>
              <td class="stack-cell">
                <div class="stack">
                  <highcharts-chart
                    [Highcharts]="Highcharts"
                    [options]="optionsByRow[i].liters"
                    [callbackFunction]="chartCallbackLitersFactory(i)"
                    style="width: 9rem; height: 30px; display: block">
                  </highcharts-chart>
                </div>
              </td>
              <td class="stack-cell">
                <div class="stack">
                  <highcharts-chart
                    [Highcharts]="Highcharts"
                    [options]="optionsByRow[i].amount"
                    [callbackFunction]="chartCallbackAmountFactory(i)"
                    style="width: 9rem; height: 30px; display: block">
                  </highcharts-chart>
                </div>
              </td>
            </tr>
          </tbody>
    </table>
</ng-container>

<div *ngIf="loading" class="text-center loader-container" style="height: 340px;">
    <div class="spinner-grow align-middle text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>